import { render } from "./SocialButtons.vue?vue&type=template&id=1f6d70c3"
import script from "./SocialButtons.vue?vue&type=script&lang=ts"
export * from "./SocialButtons.vue?vue&type=script&lang=ts"
script.render = render

export default script